import React from "react";
import { LetterReveal } from "../components/LetterReveal";
import { WordCarousel } from "../components/WordCarousel";

export const Hero: React.FC = () => {
  const words = ["React", "TypeScript", "Tailwind", "Interface", "Performance"];

  return (
    <section className="relative min-h-screen flex items-center pt-16">
      <div className="max-w-7xl mx-auto px-6 md:px-10 w-full">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-12 items-center">
          {/* Left: Identity Statement */}
          <div className="md:col-span-7">
            <div className="mb-6">
              <span className="text-sm text-muted-foreground tracking-wide font-medium">
                Frontend Developer — Kota Purwokerto
              </span>
            </div>
            <h1 className="display-type font-bold text-foreground text-balance mb-8">
              <LetterReveal text="Akbar" as="span" className="block" delay={0.1} />
              <LetterReveal text="Widya" as="span" className="block" delay={0.35} />
              <LetterReveal text="Pamungkas" as="span" className="block" delay={0.6} />
            </h1>
            <p className="text-lg md:text-xl text-muted-foreground max-w-xl leading-relaxed text-pretty">
              Merancang antarmuka yang sunyi, tajam, dan siap dipakai.
            </p>
          </div>

          {/* Right: Word Carousel + Metadata */}
          <div className="md:col-span-5 flex flex-col items-start md:items-end gap-8">
            <div className="w-full max-w-xs">
              <span className="text-xs uppercase tracking-widest text-muted-foreground mb-3 block">
                Fokus Teknologi
              </span>
              <WordCarousel
                words={words}
                className="text-2xl md:text-3xl font-semibold tracking-tight"
              />
            </div>

            <div className="text-right">
              <span className="text-xs uppercase tracking-widest text-muted-foreground mb-2 block">
                Lokasi
              </span>
              <p className="text-foreground font-medium">Purwokerto, Indonesia</p>
            </div>

            <div className="text-right">
              <span className="text-xs uppercase tracking-widest text-muted-foreground mb-2 block">
                Status
              </span>
              <p className="text-foreground font-medium">Tersedia untuk kolaborasi</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
